import { useAuth } from './useAuth';
import { useSubscription } from './useSubscription';

const TRIAL_DURATION_MS = 7 * 24 * 60 * 60 * 1000;

export function useTrialState() {
  const user = useAuth((state) => state.user);
  const { isPremium } = useSubscription();
  const trialStartedAt = user?.trialStartedAt ?? null;

  const trialExpiresAt = trialStartedAt
    ? new Date(trialStartedAt.getTime() + TRIAL_DURATION_MS)
    : null;

  const now = Date.now();
  const isInTrial = !isPremium && trialExpiresAt !== null && now < trialExpiresAt.getTime();
  const trialDaysLeft = trialExpiresAt
    ? Math.max(0, Math.ceil((trialExpiresAt.getTime() - now) / 86400000))
    : null;

  return { trialExpiresAt, isInTrial, trialDaysLeft };
}
